<template>
  <div class="page container">

    <div class="row">
      <div class="col-12 text-left">
        <router-link class='' to="/admin/produtos">  Voltar para lista de produtos</router-link>
      </div>
    </div>


    <div class="row mt-5"  >

        <div class="col-12 text-left">

          <h4> <b> Adicionar Produto </b> </h4>
           <hr/>

      <form class='text-left mt-5' ref="produto">

            <div v-if='error!=""' class="alert alert-danger">
                {{error}}
            </div>

            <div class="form-group row">
              <label class="col-sm-2 col-form-label " >*Nome </label>
                  <div class="col-sm-10">
                  <input v-model="produto.nome" type="text" class="form-control" required  >
                </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-2 col-form-label" >*Medida </label>
                      <div class="col-sm-10">
              <input v-model="produto.medida" type="text" placeholder="kg,unidade,gramas,maço,dúzia" class="form-control" required>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-2 col-form-label" >*Incremento </label>
              <div class="col-sm-10">
                <input v-model="produto.incremento" type="text" placeholder="0.5, 1, 200" class="form-control" required>
                <small id="emailHelp" class="form-text text-muted">Quando clicamo no botão +, de quanto em quanto que vai ser adicionado ao pedido </small>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-2 col-form-label" >*Preço </label>
                <div class="col-sm-10">
                  <input v-model="produto.preco" type="text" class="form-control" required>
                   <small id="emailHelp" class="form-text text-muted">casa decimal separado por . exemplo: 1.50  ou 22.60 </small>
                </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-2 col-form-label" for="">Observações </label>
                  <div class="col-sm-10">
              <textarea class="form-control" v-model="produto.informacoesadicionais"> </textarea>
              </div>
              <!-- <small id="emailHelp" class="form-text text-muted">We'll never share your email with anyone else.</small> -->
            </div>
            
            <div class="form-group row">
              <label class="col-sm-2 col-form-label" >Disponivel </label>
                <div class="col-sm-10 text-left">
                  <quantidade-selector 
                            v-model="produto.disponivel"
                            :max="Infinity"
                            :unidade="produto.medida"
                            :increment="produto.incremento || 1"
                        />
                </div>
            </div>
   

          </form>

          <a  @click="cadastrarProduto" class="btn btn-grande ">
             <span v-if="produto.id == false">Cadastrar Produto</span>
             <span v-else>Atualizar Produto</span>
          </a>
          <!-- <a v-else @click="atualizarProduto" class="btn btn-grande"> Atualizar Produto </a> -->
          
        </div>


    </div>

 




       
       

  </div>
</template>

<script>

import SelecionarProdutoEdit from '@/components/produtos/selecionar-produto-edit'
import QuantidadeSelector from '@/components/elementos/quantidade-selector'

export default {
      components:{
          QuantidadeSelector,
      },

  data(){
    return {
      error:'',
      enviado:false,
      produto:{
        id:false,
        nome:'',
        medida:'',
        incremento:'',
        preco:'',
        disponivel:0,
        informacoesadicionais:'',
      }
    }
  },


  created:function(){
      if(this.$route.params.id && this.$route.params.id != 0){
        this.produto = this.$store.getters.produtosById(this.$route.params.id)
      }
  },

  watch:{

  },


  computed:{
      listaProdutos:function(){
          return this.$store.getters.lista
      },
      produtos:function(){
          return this.$store.getters.produtos
      },
     
  },

  methods:{

    atualizarProduto:async function(){
      this.error = ""
    },

    cadastrarProduto:async function(){
      this.error = ""

     if(this.$refs['produto'].checkValidity()){
        let res
       if(this.produto.id != false){
           res = await this.$store.dispatch('updateProduto', this.produto)
       }else{
           res = await this.$store.dispatch('cadastraProduto', this.produto)
       }
       if(res!=false){
            this.$router.go(-1)
        }else{
          window.scrollTo(0,0)
          this.error = "Ocorreu um erro ao salvar o produto. Tente novamente."
        }
      }else{
          window.scrollTo(0,0)
          // alert("Preencha os dados")
          this.error = "Preencha os dados corretamente"
      }
    }
  }

}
</script>
